<template>
  <base-page-layout title="Performance operacional" class="performance-operacional" :filters="['data', 'lojas']" hide-ecommerce-configuration>
    <v-container fluid grid-list-md class="px-0">
      <div class="cards-percentage">
        <mf-data-card :text="titleCuponsCard">
          <mf-progress-bar class="progress-bar" :partialValue="clubeCuponsIdentificadosOperadores" :totalValue="clubeCuponsTotaisOperadores" />
        </mf-data-card>
        <mf-data-card :text="titleBillingCard">
          <mf-progress-bar class="progress-bar" isMoney :partialValue="clubeTotalFaturamentoOperadores" :totalValue="clubeFaturamentoTotaisOperadores" />
        </mf-data-card>
      </div>

      <v-card class="table-card" min-height="100px">
        <mf-loading loader="performance-operacional" type="card" :width="5" :height="30">
          <paginated-data-table
            :query="query"
            :query-variables="queryVariables"
            query-name="operationalPerformance"
            query-main-property-name="operators"
            :search="search"
            :headers="headers"
            default-table-sort-by="revenue_identified_percentage"
            :default-table-sort-desc="true"
            class="performance-table"
            :skip="skipComputed"
            @update-options="updatePage"
            @update:maxRecords="updateMaxRecords"
          >
            <template #top>
              <div class="table-top">
                <span class="table-card-title">Dados por operador</span>
                <v-spacer />
                <div class="d-flex align-center flex-row">
                  <export-data class="mx-2" :data-fetcher="getDataToExport" filename="dados_por_operador" ghost />
                  <mf-search v-model="search" class="pt-0 mt-0 table-top-search" width="100" hide-details placeholder="Buscar operador" />
                </div>
              </div>
            </template>
            <template #header>
              <thead>
                <tr class="headers-grouping">
                  <th></th>
                  <th></th>
                  <th class="headers-grouping__item" colspan="3">Cupons</th>
                  <th class="headers-grouping__item" colspan="3">Faturamento</th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item, index }">
              <tr :key="index">
                <td>
                  <v-tooltip top max-width="250">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item['nome'] | truncate({ length: 60 }) }}</span>
                    </template>
                    <span>{{ item['nome'] }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip :disabled="!item['unit']" top max-width="250">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item['unit'] ? item['unit']['name'] : '-' | truncate({ length: 60 }) }}</span>
                    </template>
                    <span>{{ item['unit'] ? item['unit']['name'] : '-' }}</span>
                  </v-tooltip>
                </td>
                <td>{{ item['coupons_total'] | localeString }}</td>
                <td>{{ item['coupons_identified'] | localeString }}</td>
                <td>{{ item['coupons_identified_percentage'] | abreviation | percent }}</td>
                <td>{{ item['revenue_identified_total'] | abreviation({ isCurrency: true }) | currency }}</td>
                <td>{{ item['revenue_identified'] | abreviation({ isCurrency: true }) | currency }}</td>
                <td>{{ item['revenue_identified_percentage'] | abreviation | percent }}</td>
              </tr>
            </template>
          </paginated-data-table>
        </mf-loading>
      </v-card>
    </v-container>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { mapWaitingActions } from 'vue-wait'
import { mapState, mapGetters } from 'vuex'
import { createCsvFromArray, assertArray } from '@/config/helpers.js'
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { QUERY_GET_DATA_PER_OPERATOR } from '../../graphql'
import ExportData from '@/components/export-data/ExportData.vue'
export default {
  components: {
    BasePageLayout,
    PaginatedDataTable,
    ExportData,
  },
  data: () => ({
    showTooltipProfessional: {},
    showTooltipUnit: {},
    currentPage: 1,
    pageSize: 15,
    sortBy: ['revenue_identified_percentage'],
    sortDirection: ['DESC'],
    search: '',
    maxRecords: 0,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    ...mapGetters([
      'clubeCuponsIdentificadosOperadores',
      'clubeCuponsTotaisOperadores',
      'clubePercentualCuponsIdentificadosOperadores',
      'clubeFaturamentoTotaisOperadores',
      'clubeTotalFaturamentoOperadores',
      'clubePercentualFaturamentoIdentificadoOperadores',
    ]),
    query() {
      return QUERY_GET_DATA_PER_OPERATOR
    },
    titleCuponsCard() {
      return 'Total do percentual de cupons identificados'
    },
    titleBillingCard() {
      return 'Total do percentual de faturamento identificado'
    },
    headers() {
      return [
        {
          text: 'Nome',
          value: 'nome',
          align: 'left',
          width: '25%',
        },
        {
          text: 'Loja',
          value: 'unit',
          align: 'left',
          width: '25%',
        },
        {
          text: 'Total',
          value: 'coupons_total',
          align: 'left',
          class: 'left-line',
        },
        {
          text: 'Identificados',
          value: 'coupons_identified',
          align: 'left',
        },
        {
          text: '% ident.',
          value: 'coupons_identified_percentage',
          align: 'left',
        },
        {
          text: 'Total',
          value: 'revenue_identified_total',
          align: 'left',
          class: 'left-line',
        },
        {
          text: 'Identificado',
          value: 'revenue_identified',
          align: 'left',
        },
        {
          text: '% ident.',
          value: 'revenue_identified_percentage',
          align: 'left',
        },
      ]
    },
    queryVariables() {
      const { data } = this.stateFilters
      const [initialDate = '', finalDate = ''] = assertArray(data)
      return {
        initialDate,
        finalDate,
        units: this.stateFilters.units,
        page: this.currentPage,
        sort: this.sortBy,
        sortDirection: this.sortDirection,
      }
    },
    filters() {
      return {
        date: this.stateFilters.data,
        unidades: this.stateFilters.units,
      }
    },
    skipComputed() {
      return !this.stateFilters.units || this.stateFilters.units.length < 1
    },
  },
  async mounted() {
    await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      clubePerformanceOperacional: 'performance-operacional',
      clubePercentualCuponsIdentificados: 'percentual-cupons',
      clubePercentualFaturamentoIdentificado: 'percentual-faturamento',
    }),
    redirect(param) {
      this.$router.push({ path: `performance-operacional/detalhes-operador/`, query: { id: param } }).catch(() => {})
    },
    getData() {
      this.clubePercentualCuponsIdentificados(this.filters)
      this.clubePercentualFaturamentoIdentificado(this.filters)
      this.currentPage = 1
    },
    async getDataToExport() {
      try {
        let variables = JSON.parse(JSON.stringify(this.queryVariables))
        variables = {
          ...variables,
          pageSize: this.maxRecords,
          search: this.search,
          page: 1,
        }
        const { data } = await this.$apollo.query({
          query: this.query,
          variables: variables,
          fetchPolicy: 'no-cache',
        })
        const headers = [
          'Nome',
          'Loja',
          'Total cupons',
          'Cupons identificados',
          'Percentual cupons identificados',
          'Total faturamento',
          'Faturamento identificado',
          'Percentual faturamento identificado',
        ]
        const rows = data.operationalPerformance.operators.map((operator) => {
          return [
            operator.nome,
            operator.unit.name,
            operator.coupons_total,
            operator.coupons_identified,
            operator.coupons_identified_percentage,
            Number(operator.revenue_identified_total.toFixed(2)),
            Number(operator.revenue_identified.toFixed(2)),
            operator.revenue_identified_percentage,
          ]
        })
        return { headers, rows }
      } catch {
        this.$snackbar({ message: 'Falha ao tentar exportar como csv' })
      }
    },
    async downloadCsv() {
      const csvHeaders = [
        'Nome',
        'Loja',
        'Total cupons',
        'Cupons identificados',
        'Percentual cupons identificados',
        'Total faturamento',
        'Faturamento identificado',
        'Percentual faturamento identificado',
      ]
      let variables = JSON.parse(JSON.stringify(this.queryVariables))
      variables = {
        ...variables,
        pageSize: this.maxRecords,
        search: this.search,
        page: 1,
      }
      try {
        const { data } = await this.$apollo.query({
          query: this.query,
          variables: variables,
          fetchPolicy: 'no-cache',
        })
        const dataCSV = data?.['operationalPerformance']?.['operators'].map((operator) => {
          return {
            nome: operator.nome,
            loja: operator.unit?.name,
            totalCupons: operator.coupons_total,
            cuponsIdentificados: operator.coupons_identified,
            percentualCuponsIdentificados: operator.coupons_identified_percentage,
            totalFaturamento: operator.revenue_identified_total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            totalFaturamentoIdentificado: operator.revenue_identified.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            percentualFaturamentoIdentificado: `${operator.revenue_identified_percentage}%`,
          }
        })
        createCsvFromArray(dataCSV, 'operational_performance', csvHeaders)
      } catch {
        this.$snackbar({ message: 'Falha ao tentar exportar como csv' })
      }
    },
    updatePage(options) {
      this.currentPage = options.page
      this.pageSize = options.itemsPerPage
      this.sortBy = options.sortBy[0]
      this.sortDirection = options.sortDesc[0] ? 'DESC' : 'ASC'
    },
    updateMaxRecords(records) {
      this.maxRecords = records
    },
  },
}
</script>

<style lang="scss" scoped>
.performance-operacional {
  ::v-deep .cards-percentage {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    margin: 0 -3px;
    .v-card__text {
      padding: 16px 16px 22px;
    }
  }
  ::v-deep .performance-table {
    margin-top: 15px;
    .table-top {
      display: flex;
      padding: 24px 24px 32px;
      &-csv {
        font-size: 12px;
        letter-spacing: 0.01em;
        color: $marca-0-l40 !important;
        text-transform: none;
        -webkit-text-decoration-line: none;
        text-decoration-line: none;
        margin-right: 20px;
        align-self: center;
      }
      &-search {
        max-width: 260px;
      }
    }
    .headers-grouping {
      th {
        height: 21px;
        border-bottom: none !important;
        font-size: 14px;
        color: $cinza-d20 !important;
        padding-bottom: 8px;
      }
      &__item {
        border-left: 1px solid #9a9a9a !important;
        font-weight: 400;
      }
    }
    th {
      padding-bottom: 11px;
      border-bottom: 1px solid #9a9a9a !important;
      &.text-left {
        font-size: 12px;
        line-height: 14px;
        color: $cinza-d10;
        font-weight: 400;
        padding-bottom: 11px;
        height: 14px;
      }
    }
    .left-line {
      border-left: 1px solid $cinza-l30;
    }
    .v-data-table__progress th {
      padding: 0;
    }
  }
  .progress-bar {
    padding-top: 12px;
  }
}
</style>
